import React, { useState, useEffect } from "react";
import TooltipButton from "../../Button/TooltipButton";
import OrangeGradientButton from "../../Button/OrangeGradientButton";
import api from "../../../api/baseUrl";
import ExportExcelButton from "../../Button/ExportExcelButton";

import edidIcon from "../../../icons/edit.svg";
import deleteIcon from "../../../icons/trash.svg";
import viewIcon from "../../../icons/Property 1=broken (5).svg";
import PrimaryButton from "../../Button/primaryButton/PrimaryButton";
import Snackbar from "../../SnackBar/SnackBar";
import Dropdown from "../DropDown/DropDown.js";
import SkeletonLoader from "../../SkeletonLoader/SkeletonLoader.js";
import NoData from "../../NoData/NoData.js";

// مودال
const Modal = ({ isOpen, onClose, children, fullscreen = false }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className={`modal ${fullscreen ? "fullscreen" : ""}`} onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>✕</button>
                {children}
            </div>
        </div>
    );
};

const TableSellers = ({ sellers = [], refreshDataSellers, title, sellersPagesCount }) => {
    const [showModal, setShowModal] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [formData, setFormData] = useState({});
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [snackbar, setSnackbar] = useState({ message: "", type: "info" });
    const [modalOpen, setModalOpen] = useState(false);
    const [viewingItem, setViewingItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showNoData, setShowNoData] = useState(false);

    const [phoneError, setPhoneError] = useState("");


    
    // برای جستجو
    const [searchQuery, setSearchQuery] = useState(""); // مقدار تایپ شده
    const [appliedSearch, setAppliedSearch] = useState(""); // مقدار تایید شده با Enter

    // برای صفحه‌بندی
    const [currentPage, setCurrentPage] = useState(1);

    const [dataAllSeller, setDataAllSeller] = useState(1);

    const [pagesCount, setPagesCount] = useState(1);
    // const [pageSellers, setPageSellers] = useState([]); // آیتم‌های صفحه فعلی
    const [activeTab, setActiveTab] = useState("active"); // active یا archive
    const [pageSellers, setPageSellers] = useState({
        normalMessages: [],
        archiveMessages: [],
        pagesCount: 1,
    });

    // const fetchPage = async (page = 1, search = "") => {
    //     let timer;
    //     try {
    //         timer = setTimeout(() => setLoading(true), 200);
    //         const data = await refreshDataSellers(page, search); // باید تو parent این تابع را داشته باشی
    //         if (!data) return;
    //         setPageSellers(data.messages || []);
    //         setPagesCount(data.pagesCount || 1);
    //     } catch (err) {
    //         console.error("Error fetching sellers:", err);
    //     } finally {
    //         clearTimeout(timer);
    //         setLoading(false);
    //     }
    // };


    // useEffect(() => {
    //     fetchPage(currentPage, appliedSearch);
    // }, [currentPage, appliedSearch]);


    const fetchPage = async (page = 1, search = "") => {
        let timer;
        try {
            timer = setTimeout(() => setLoading(true), 1000);
            const data = await refreshDataSellers(page, search, activeTab === "archive");
            if (!data) return;
            setPageSellers(data);
            setPagesCount(data.pagesCount || 1);
        } catch (err) {
            console.error("Error fetching sellers:", err);
        } finally {
            clearTimeout(timer);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPage(currentPage, appliedSearch);
    }, [currentPage, appliedSearch, activeTab]);

    const displayedSellers = activeTab === "archive" ? pageSellers.archiveMessages : pageSellers.normalMessages;


    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setCurrentPage(1); // همیشه از صفحه 1 شروع شود
            setAppliedSearch(searchQuery.trim());
        }
    };
    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > pagesCount) return;
        setCurrentPage(newPage);
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));



    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        let url = "/crud-sellers";

        let body = editingItem
            ? {
                action: "update",
                id: editingItem.id,
                name: formData.name || "",
                surname: formData.surname || "",
                phone_number: formData.phone || "",
                landline_number: formData.land_line || "",
                address: formData.address || "",
                city: formData.city || "",
                province: formData.province || "",
                shop_name: formData.shop_name || "",
            }
            : {
                action: "add",
                name: formData.name || "",
                surname: formData.surname || "",
                phone_number: formData.phone || "",
                landline_number: formData.land_line || "",
                address: formData.address || "",
                city: formData.city || "",
                province: formData.province || "",
                shop_name: formData.shop_name || "",
            };

        try {
            const result = await api.post(url, body);

            if (editingItem) {
                setSnackbar({
                    title: "موفقیت",
                    description: `فروشگاه "${formData.shop_name}" با موفقیت به‌روزرسانی شد!`,
                    type: "success"
                });
            } else {
                setSnackbar({
                    title: "موفقیت",
                    description: `فروشگاه "${formData.shop_name}" با موفقیت اضافه شد!`,
                    type: "success"
                });
            }

            fetchPage(currentPage, appliedSearch);

            setShowModal(false);
            setFormData({});
        } catch (error) {
            console.error("خطا در ارسال داده:", error);
            setSnackbar({
                title: "ناموفق",
                description: editingItem
                    ? `به‌روزرسانی فروشگاه "${formData.shop_name}" ناموفق بود!`
                    : `افزودن فروشگاه "${formData.shop_name}" ناموفق بود!`,
                type: "error"
            });
        }
    };









   const handleGetDataAllSeller = async (page = 1) => {
  try {
    const result = await api.get("/get-sellers", { params: { page, limit: 1000 } });
    return result.data.messages; // <-- برگرداندن داده‌ها برای اکسل
  } catch (error) {
    console.error("خطا:", error);
    alert("خطا در دریافت اطلاعات");
    return [];
  }
};












    const handleEditClick = (seller) => {
        setEditingItem(seller);
        setFormData({ ...seller });
        setShowModal(true);
    };
    const handleDelete = async (id) => {
        // const sellerToDelete = sellers.messages.find(s => s.id === id);

        const sellerToDelete =
            (pageSellers.normalMessages || []).find(s => s.id === id) ||
            (pageSellers.archiveMessages || []).find(s => s.id === id);
        try {
            const result = await api.post("/crud-sellers", { action: "delete", id });
            if (result.data.accepted) {
                fetchPage(currentPage, appliedSearch);

                setSnackbar({
                    title: "موفقیت",
                    description: `فروشگاه "${sellerToDelete.shop_name}" با موفقیت حذف شد!`,
                    type: "success"
                });
            }
        } catch (error) {
            console.error("خطا در حذف:", error);
            setSnackbar({
                title: "ناموفق",
                description: `حذف فروشگاه "${sellerToDelete.shop_name}" ناموفق بود!`,
                type: "error"
            });
        }
    };

    const handleSeeDetails = async (id) => {
        try {
            const result = await api.post("/crud-sellers", { action: "get", id });
            setViewingItem(result.data.message[0]);
            setEditingItem(null);
            setModalOpen(true);
        } catch (error) {
            console.error("خطا در مشاهده:", error);
            setSnackbar({ message: "خطا در مشاهده", type: "error" });
        }
    };


    useEffect(() => {
        if (!loading) {
            if (displayedSellers.length === 0) {
                // کمی تاخیر قبل از نمایش NoData
                const timer = setTimeout(() => setShowNoData(true), 1000);
                return () => clearTimeout(timer);
            } else {
                setShowNoData(false);
            }
        }
    }, [loading, displayedSellers]);


    return (
        <div className="">
            {/* <div className="card-header">
                <h2>{title}</h2>
                <div className="search-container">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="جستجو بر اساس نام، شهر یا فروشگاه..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={handleSearchKeyDown}
                    />
                </div>

                <div className="button-group-header-card">
                    <ExportExcelButton data={sellers} />
                    <OrangeGradientButton onClick={() => { setEditingItem(null); setFormData({}); setShowModal(true); }}>
                        افزودن فروشگاه
                    </OrangeGradientButton>
                </div>
            </div> */}





            <div className="card-header">
                <h2>{title}</h2>

                <div className="header-actions">
                    <div className="search-container">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="جستجو بر اساس نام، شهر یا فروشگاه..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={handleSearchKeyDown}
                        />
                    </div>

                    <div className="button-group-header-card">
<ExportExcelButton  fetchData={handleGetDataAllSeller} />
                        <OrangeGradientButton onClick={() => { setEditingItem(null); setFormData({}); setShowModal(true); }}>
                            افزودن فروشگاه
                        </OrangeGradientButton>
                    </div>
                </div>
            </div>

            <div className="table-container">
                <div className="tabs-container">
                    <button
                        className={`tab-button ${activeTab === "active" ? "active" : ""}`}
                        onClick={() => setActiveTab("active")}
                    >
                        فعال
                    </button>
                    <button
                        className={`tab-button ${activeTab === "archive" ? "active" : ""}`}
                        onClick={() => setActiveTab("archive")}
                    >
                        بایگانی
                    </button>
                </div>



                {loading ? (
                    <SkeletonLoader rows={20} />
                ) : displayedSellers.length > 0 ? (
                    <>
                        <table>
                            <thead>
                                <tr>
                                    <th>نام</th>
                                    <th className="responsive-title">نام خانوادگی</th>
                                    {/* <th>کد ملی</th> */}
                                    <th>شماره تماس</th>
                                    <th>تلفن ثابت</th>
                                    <th className="responsive-title">نام فروشگاه</th>
                                    <th>استان</th>
                                    <th>شهر</th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayedSellers.map((seller) => (
                                    <tr key={seller.id}>
                                        <td>{seller.name}</td>
                                        <td>{seller.surname}</td>
                                        <td>{seller.phone}</td>
                                        <td>{seller.land_line}</td>
                                        <td>{seller.shop_name}</td>
                                        <td>{seller.province}</td>
                                        <td>{seller.city}</td>
                                        <td>
                                            <div className="button-group">
                                                <TooltipButton icon={edidIcon} alt="ویرایش" tooltipText="ویرایش" onClick={() => handleEditClick(seller)} />
                                                <TooltipButton icon={viewIcon} alt="جزئیات" tooltipText="جزئیات" onClick={() => handleSeeDetails(seller.id)} className="margin-btn" />
                                                <TooltipButton icon={deleteIcon} alt="حذف" tooltipText="حذف" onClick={() => { setDeleteItemId(seller.id); setDeleteModalOpen(true); }} className="delete-btn margin-btn" />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>



                        </table>

                        {snackbar.title && (
                            <Snackbar
                                title={snackbar.title}
                                description={snackbar.description}
                                type={snackbar.type}
                                duration={2000}
                                onClose={() => setSnackbar({ title: "", description: "", type: "info" })}
                            />
                        )}<div className="pagination">
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                قبلی
                            </button>

                            {Array.from({ length: pagesCount }, (_, i) => i + 1)
                                .filter(
                                    (page) =>
                                        page === 1 ||
                                        page === pagesCount ||
                                        (page >= currentPage - 1 && page <= currentPage + 1)
                                )
                                .map((page, idx, arr) => {
                                    const prev = arr[idx - 1];
                                    if (prev && page - prev > 1)
                                        return (
                                            <React.Fragment key={page}>
                                                <span style={{ padding: "0 5px" }}>...</span>
                                                <button
                                                    onClick={() => handlePageChange(page)}
                                                    className={currentPage === page ? "active" : ""}
                                                >
                                                    {page}
                                                </button>
                                            </React.Fragment>
                                        );

                                    return (
                                        <button
                                            key={page}
                                            onClick={() => handlePageChange(page)}
                                            className={currentPage === page ? "active" : ""}
                                        >
                                            {page}
                                        </button>
                                    );
                                })}

                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === pagesCount}
                            >
                                بعدی
                            </button>
                        </div>
                    </>) : showNoData ? (
                        <div className="no-data-message">
                            <NoData message="هیچ فروشگاهی یافت نشد" />
                        </div>
                    ) : null}
















            </div>


            {/* مودال افزودن/ویرایش */}

            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <h2 className="modal-title">
                    {editingItem ? "ویرایش فروشگاه" : "افزودن فروشگاه جدید"}
                </h2>

                <form className="modal-form" onSubmit={handleSubmit}>
                    {/* فیلدهای عمومی */}
                    {[
                        { key: "name", label: "نام", type: "text", required: true, maxLength: 45 },
                        { key: "surname", label: "نام خانوادگی", type: "text", required: true, maxLength: 45 },
                        { key: "land_line", label: "تلفن ثابت", type: "text", required: false, maxLength: 14 },
                        { key: "shop_name", label: "نام فروشگاه", type: "text", required: true, maxLength: 45 },
                    ].map((field) => (
                        <div key={field.key} className="form__input-group">
                            <input
                                id={field.key}
                                name={field.key}
                                type={field.type}
                                value={formData[field.key] || ""}
                                placeholder=" "
                                required={field.required}
                                maxLength={field.maxLength}
                                className="form__input"
                                onChange={(e) => {
                                    const { name, value } = e.target;

                                    if (name === "land_line") {
                                        // فقط اعداد
                                        let val = value.replace(/\D/g, "");
                                        if (val.length > field.maxLength) val = val.slice(0, field.maxLength);
                                        setFormData((prev) => ({ ...prev, [name]: val }));
                                    } else {
                                        setFormData((prev) => ({ ...prev, [name]: value }));
                                    }
                                }}
                            />
                            <label htmlFor={field.key} className="form__input-label">
                                {field.label}
                            </label>
                        </div>
                    ))}

                    {/* شماره تماس با طراحی اختصاصی و لیبل شناور */}
                    <div className="phone-input-container">
                        <div className="phone-input-wrapper">
                            <span className="phone-prefix">09</span>
                            <input
                                id="phone"
                                name="phone"
                                type="text"
                                className={`phone-input ${phoneError ? "has-error" : ""}`}
                                value={formData.phone?.slice(2) || ""}
                                placeholder=" "
                                required
                                maxLength={9}
                                onChange={(e) => {
                                    let val = e.target.value.replace(/\D/g, "");
                                    if (val.length > 9) val = val.slice(0, 9);

                                    setFormData((prev) => ({ ...prev, phone: "09" + val }));

                                    if (val.length < 9)
                                        setPhoneError("شماره تماس باید ۱۱ رقم باشد (مثل 09123456789)");
                                    else setPhoneError("");
                                }}
                            />
                            <label htmlFor="phone" className="phone-label">شماره تماس</label>
                        </div>

                        {phoneError && <span className="phone-error">{phoneError}</span>}
                    </div>



                    {/* استان و شهر */}
                    <div className="form__input-group">
                        <Dropdown
                            type="provinceCity"
                            value={{ province: formData.province, city: formData.city }}
                            // onChange={(val) => {
                            //     const { province, city } = val;
                            //     setFormData((prev) => ({
                            //         ...prev,
                            //         province,
                            //         city,
                            //         address: city && province ? `${province},${city},` : prev.address,
                            //     }));
                            // }}

                            onChange={(val) => {
                                const { province, city } = val;
                                setFormData((prev) => ({
                                    ...prev,
                                    province,
                                    city,
                                    address: !prev.address && city && province ? `${province} , ${city} , ` : prev.address,
                                }));
                            }}

                        />
                    </div>

                    {/* آدرس */}
                    <div className="form__input-group">
                        <input
                            id="address"
                            name="address"
                            type="text"
                            value={formData.address || ""}
                            onChange={(e) =>
                                setFormData((prev) => ({ ...prev, address: e.target.value }))
                            }
                            placeholder=" "
                            required
                            maxLength={300}
                            className="form__input"
                        />
                        <label htmlFor="address" className="form__input-label">
                            آدرس
                        </label>
                    </div>

                    <PrimaryButton
                        title="ذخیره"
                        type="submit"
                        loading={loading}
                        disabled={!!phoneError}
                    />
                </form>
            </Modal>

            {/* مودال حذف */}
            {isDeleteModalOpen && (
                <Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
                    <h3 className="delete-modal-title">آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟</h3>
                    <div className="modal-buttons">
                        <button className="btn cancel-btn" onClick={() => setDeleteModalOpen(false)}>انصراف</button>
                        <button className="btn confirm-btn" onClick={() => { handleDelete(deleteItemId); setDeleteModalOpen(false); }}>تایید</button>
                    </div>
                </Modal>
            )}

            {/* مودال جزئیات */}
            {modalOpen && viewingItem && (
                <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
                    <div className="modal-info-content">
                        <h3 className="modal-title">جزئیات فروشگاه</h3>
                        <div className="modal-info">
                            <div className="info-row">
                                <span className="info-label">نام:</span>
                                <span className="info-value">{viewingItem.name}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">نام خانوادگی:</span>
                                <span className="info-value">{viewingItem.surname}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">شماره تماس:</span>
                                <span className="info-value">{viewingItem.phone}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">تلفن ثابت:</span>
                                <span className="info-value">{viewingItem.landline_number}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">نام فروشگاه:</span>
                                <span className="info-value">{viewingItem.shop_name}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">استان:</span>
                                <span className="info-value">{viewingItem.province}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">شهر:</span>
                                <span className="info-value">{viewingItem.city}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">آدرس:</span>
                                <span className="info-value">{viewingItem.address}</span>
                            </div>

                            <div className="info-row">
                                <span className="info-label">مشخصات ویزیتور :</span>
                                <span className="info-value">{viewingItem.marketer_name} {viewingItem.marketer_surname} - {viewingItem.marketer_phone}</span>
                            </div>

                            
                            {/* <div className="info-row">
                <span className="info-label">مارکتر:</span>
                <span className="info-value">{viewingItem.marketer}</span>
            </div> */}
                        </div>
                    </div>
                </Modal>

            )}



        </div>
    );
};

export default TableSellers;
